<script>
	import { version } from "../store/stores";
</script>

<div class="watermark">
	<div class="watermark__info">
		<p><span>A <b>sbooky.io</b> game</span>Version: {$version}</p>
	</div>
	<div class="watermark__logo">
		<svg
			width="36"
			height="44"
			viewBox="0 0 36 44"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				opacity="0.54"
				d="M3.42929 19.5799C3.42929 24.363 5.66371 31.9131 6.78243 34.9541C7.90116 37.9951 8.23224 39.3559 9.19283 39.3559C10.1534 39.3559 10.3135 35.3492 11.7544 35.2581C13.1953 35.167 13.4928 41.0443 14.476 41.1978C16.2282 41.4714 15.2934 38.2661 16.4772 38.6274C18.0801 39.1166 17.7971 44.0001 19.1988 44.0001C20.6006 44.0001 19.528 37.6257 21.2801 37.6257C23.0323 37.6257 23.2048 41.1978 24.6066 41.1978C26.0083 41.1978 27.2429 33.2908 28.6446 32.8905C30.0463 32.4901 30.2135 38.7645 31.6153 34.9541C33.3674 30.1912 34.9684 24.363 34.9684 19.5799C35.0266 8.09201 27.9265 1.56494 19.1988 1.56494C10.4712 1.56494 3.26612 7.77857 3.42929 19.5799Z"
				fill="#EAF4FD"
			/>
			<path
				d="M35.9969 18.0149C35.9969 22.7981 33.4467 30.3482 32.1699 33.3892C30.893 36.4302 30.5151 37.791 29.4188 37.791C28.3225 37.791 28.1397 33.7842 26.4952 33.6932C24.8507 33.6021 24.5111 39.4793 23.3889 39.6328C21.3891 39.9064 22.4561 36.7012 21.1049 37.0625C19.2755 37.5516 19.5985 42.4352 17.9987 42.4352C16.3988 42.4352 17.623 36.0608 15.6232 36.0608C13.6234 36.0608 13.4265 39.6328 11.8267 39.6328C10.2268 39.6328 8.81777 31.7259 7.21793 31.3255C5.61808 30.9252 5.42729 37.1995 3.82744 33.3892C1.82764 28.6263 0.000405956 22.7981 0.000405956 18.0149C-0.0660591 6.52707 8.03753 4.77084e-07 17.9987 0C27.9598 -4.77084e-07 36.1831 6.21362 35.9969 18.0149Z"
				fill="#EAF4FD"
			/>
			<path
				d="M30.0287 13.1618C30.0287 15.8038 27.8799 16.9412 25.2292 16.9412C22.5785 16.9412 20.4297 15.8038 20.4297 13.1618C20.4297 10.5197 22.5785 8.37793 25.2292 8.37793C27.8799 8.37793 30.0287 10.5197 30.0287 13.1618Z"
				fill="#050E18"
			/>
			<ellipse
				cx="0.472752"
				cy="0.473135"
				rx="0.472752"
				ry="0.473135"
				transform="matrix(0.608849 0.793286 0.795209 -0.606335 26.1055 10.7319)"
				fill="#EAF4FD"
			/>
			<ellipse
				cx="1.16936"
				cy="1.17031"
				rx="1.16936"
				ry="1.17031"
				transform="matrix(0.608849 0.793286 0.795209 -0.606335 22.8398 10.5068)"
				fill="#EAF4FD"
			/>
			<path
				d="M15.6303 13.1618C15.6303 15.8038 13.4815 16.9412 10.8308 16.9412C8.18007 16.9412 6.03125 15.8038 6.03125 13.1618C6.03125 10.5197 8.18007 8.37793 10.8308 8.37793C13.4815 8.37793 15.6303 10.5197 15.6303 13.1618Z"
				fill="#050E18"
			/>
			<ellipse
				cx="0.472752"
				cy="0.473135"
				rx="0.472752"
				ry="0.473135"
				transform="matrix(0.608849 0.793286 0.795209 -0.606335 11.6719 10.8462)"
				fill="#EAF4FD"
			/>
			<ellipse
				cx="1.16936"
				cy="1.17031"
				rx="1.16936"
				ry="1.17031"
				transform="matrix(0.608849 0.793286 0.795209 -0.606335 8.40625 10.6211)"
				fill="#EAF4FD"
			/>
			<path
				d="M19.9179 17.2693C20.7414 17.4581 19.5411 19.338 18.0906 19.3055C16.6402 19.2731 15.3858 17.4222 16.2634 17.2693C17.141 17.1164 17.0815 18.2432 18.0906 18.2432C19.0998 18.2432 19.0943 17.0804 19.9179 17.2693Z"
				fill="#050E18"
			/>
		</svg>
	</div>
</div>

<style>
	.watermark {
		position: fixed;
		pointer-events: none;
		opacity: 0.25;
		bottom: 20px;
		left: 20px;
		display: flex;
		align-items: center;
		flex-direction: row-reverse;
		gap: 10px;
	}
	.watermark__logo {
		display: flex;
		align-items: center;
		gap: 20px;
		text-transform: uppercase;
	}

	.watermark__logo svg {
		width: 36px;
		height: 44px;
	}
	.watermark__info p {
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 2px;
		margin: 0;
	}
	.watermark__info span {
		display: block;
		font-size: 12px;
		font-weight: 400;
	}

	.watermark__info b {
		font-weight: 700 !important;
	}
</style>
